"use client";

import { CollectionScopedContextProvider, useCollectionProviderContext } from "../__chunks/G4PVPWEW.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import { useWrapElement } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest } from "../__chunks/3YLGPPWQ.js";

// src/collection/collection.tsx
import { removeUndefinedValues } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useCollection = createHook(function useCollection2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useCollectionProviderContext();
  store = store || context;
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(CollectionScopedContextProvider, {
      value: store,
      children: element
    });
  }, [store]);
  return removeUndefinedValues(props);
});
var Collection = forwardRef(function Collection2(props) {
  var htmlProps = useCollection(props);
  return createElement(TagName, htmlProps);
});
export { Collection, useCollection };